import pug from 'javascripts/work_tags/templates/invite_coauthor_modal.jst.pug';
window.JST = window.JST || {};
window.JST['work_tags/templates/invite_coauthor_modal'] = pug;
